import { createEventEmitter } from '@nzyme/utils/createEventEmitter.js';

export const focusInput = createEventEmitter();
